import {combineReducers} from 'redux'
import managePublications from './PublicationsContainer/reducers/managePublications'

const rootReducer = combineReducers({ managePublications })

export default rootReducer
